import { render, staticRenderFns } from "./UserSettingsDialog.vue?vue&type=template&id=b2b1771c&scoped=true"
import script from "./UserSettingsDialog.vue?vue&type=script&lang=js"
export * from "./UserSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./UserSettingsDialog.vue?vue&type=style&index=0&id=b2b1771c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b1771c",
  null
  
)

export default component.exports